/**
 * Regole pure delle reazioni in bolla (niente React: i test girano in node).
 */
import { BUSINESS_REACTION_SENDER } from '@/lib/services/whatsapp/cloudPayloads';

interface ReactionLike {
  emoji: string;
  users: string[];
}

export function isMyReaction(reaction: ReactionLike): boolean {
  return reaction.users.includes(BUSINESS_REACTION_SENDER);
}

/** Emoji da inviare al clic: la stessa gia' messa da noi si toglie (stringa vuota). */
export function nextReactionEmoji(reactions: ReactionLike[] | undefined, emoji: string): string {
  const mine = (reactions ?? []).find(isMyReaction);
  return mine?.emoji === emoji ? '' : emoji;
}

export interface SenderNameContext {
  isGroup: boolean;
  chatName?: string;
  /** senderJid -> nome, dai messaggi del gruppo. */
  names?: Map<string, string>;
  /** Numero leggibile quando il nome non si conosce. */
  formatNumber: (jid: string) => string;
}

/** Nome da mostrare al posto dell'identificativo. Mai un @lid o un @g.us a schermo. */
export function reactionSenderName(jid: string, ctx: SenderNameContext): string {
  if (jid === BUSINESS_REACTION_SENDER) return 'Tu';
  const known = ctx.names?.get(jid);
  if (known) return known;
  if (!ctx.isGroup) return ctx.chatName || ctx.formatNumber(jid);
  return jid.endsWith('@c.us') ? ctx.formatNumber(jid) : 'Un partecipante';
}
